import { render, staticRenderFns } from "./SendingSettings.vue?vue&type=template&id=6abb48fd&"
import script from "./SendingSettings.vue?vue&type=script&lang=js&"
export * from "./SendingSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports